import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'morva-cancel-datasource-dialog',
  templateUrl: './cancel-datasource-dialog.component.html',
  styleUrl: './cancel-datasource-dialog.component.scss'
})
export class CancelDatasourceDialogComponent {
  
  item: any;

  constructor(protected dialogRef: NbDialogRef<any>) {}

  closeDialog() {
    this.dialogRef.close(false);
  }

  CancelDataSourceUploadProgress() {
    this.dialogRef.close(true);
  }
}
